<template>
  <!-- 电子户信息 -->
  <div ref="registrInfoRef">
    <!-- 法人信息 -->
    <div class="manage-card-box">
      <div class="info-card-title">
        法人信息
      </div>
      <div class="base-info-list">
        <div class="left-list gap-y-[14px]">
          <div class="item">
            <div class="label">
              法定代表人姓名
            </div>
            <div class="value">
              {{ data.legalName }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              法定代表人证件号
            </div>
            <div class="value">
              {{ data.legalIdNo }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              法定代表人性别
            </div>
            <div class="value">
              {{ data?.legalGender == 'MALE'?'男':data?.legalGender == 'FEMALE'?'女':'' }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              证件地址
            </div>
            <div class="value">
              {{ data.legalContactAddress }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              证件有效期
            </div>
            <div class="value">
              <span>{{ changeFormatToDate(data.idNoExpiryStartDate) }}</span>
              <span> ~ </span>
              <span>{{ changeFormatToDate(data.idNoExpiryEndDate) }}&nbsp;&nbsp;</span>
              <span>{{ isLongTime ? '长期' : '' }}</span>
            </div>
          </div>
        </div>
        <div class="right-list">
          <div class="item">
            <div class="label">
              证件类型
            </div>
            <div class="value">
              身份证
            </div>
          </div>
          <div class="item">
            <div class="label">
              法定代表人民族
            </div>
            <div class="value">
              {{ data.legalNation }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              法定代表人电话
            </div>
            <div class="value">
              {{ data.legalPhone }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              发证机关
            </div>
            <div class="value">
              {{ data.legalCardCreateUnit }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 店铺信息 -->
    <div class="manage-card-box my-5">
      <div class="info-card-title">
        店铺信息
      </div>
      <yibao-shop-info
        readonly
        :data="data.shopList || []"
        :is-show-tag="false"
      />
    </div>

    <!-- 受益人信息 -->
    <div class="manage-card-box my-5">
      <div class="info-card-title">
        受益人信息
      </div>
      <beneficiary-info
        ref="beneficiaryInfoRef"
        type="detail"
        :data="data.uboList"
      />
    </div>

    <!-- 分账资质信息 -->
    <div class="manage-card-box my-5">
      <div class="info-card-title">
        分账资质信息
      </div>
      <div class="base-info-list">
        <div class="left-list gap-y-[14px]">
          <div class="item">
            <div class="label flex">
              付款协议 <el-tooltip
                class="auth-tooltip"
                effect="light"
                content="提供完整付款协议，且内容需体现出款场景;要求甲乙双方鲜章、骑缝章、协议内容完整"
                placement="right"
              >
                <svg-icon
                  icon="mingcute:information-line"
                  class="main-primary-text cursor-pointer !w-[16px] relative ml-1"
                />
              </el-tooltip>
            </div>
            <div class="value">
              <el-link type="primary" :underline="false" @click="(e) => openService(data.agreementPhotoUrl, e)">
                {{ data.agreementPhotoName }}
              </el-link>
            </div>
          </div>
          <template v-if="data.shareScene">
            <div v-for="(item,index) in Comps[data.shareScene]" :key="index" class="item">
              <div class="label flex ">
                {{ item.name }} <el-tooltip
                  v-if="item.desc"
                  class="auth-tooltip"
                  effect="light"
                  :content="item.desc"
                  placement="right"
                >
                  <svg-icon
                    icon="mingcute:information-line"
                    class="main-primary-text cursor-pointer !w-[16px] relative ml-1"
                  />
                </el-tooltip>
              </div>
              <div v-if="item.type=='upload'" class="value">
                <el-link type="primary" :underline="false" @click="(e) => openService(data[`shareCertificate${index+1}`], e)">
                  {{ data[`shareCertificate${index+1}Name`] ? data[`shareCertificate${index+1}Name`] : data[`shareCertificate${index+1}`] }}
                </el-link>
              </div>
              <div v-if="item.type=='img'" class="value">
                <div class="business-license-box">
                  <img :src="data[`shareCertificate${index+1}`]" alt="">
                </div>
              </div>
              <div v-if="item.type=='textarea'" class="value">
                {{ data[`shareCertificate${index+1}`] }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { changeFormatToDate } from '@core/tools';
import { computed, PropType, ref } from 'vue';
import { useElementImgPreview, SvgIcon } from '@vue3/components';
import { BeneficiaryInfo, YibaoShopInfo } from '../../../..';
import { IYibaoDetail } from '../../../../types/yibao';
import { Comps } from './meta';

defineOptions({ name: 'ElectronicHouseholdInfo' });

const props = defineProps({
  data: {
    type: Object as PropType<IYibaoDetail>,
    default() {
      return {} as IYibaoDetail;
    },
  },
});

const registrInfoRef = ref<HTMLDivElement>();

const isLongTime = computed(() => props.data.idNoExpiryEndDate && ['29991231', '2999-12-31'].includes(props.data.idNoExpiryEndDate));

useElementImgPreview(registrInfoRef);

function openService(url: string, e: MouseEvent) {
  e.stopPropagation();
  window.open(`/account/office-previewer?url=${url}`);
}
</script>
